/**
 * Currency formatting utility.
 *
 * CURRENCY_OPTIONS lists the currencies available in the Settings dropdown.
 * formatCurrency() formats a number using the active currency config.
 */

export const CURRENCY_OPTIONS = [
  { code: "USD", symbol: "$", locale: "en-US", label: "USD ($)" },
  { code: "GBP", symbol: "\u00a3", locale: "en-GB", label: "GBP (\u00a3)" },
  { code: "EUR", symbol: "\u20ac", locale: "de-DE", label: "EUR (\u20ac)" },
];

const DEFAULT_CURRENCY = { code: "USD", symbol: "$", locale: "en-US" };

/**
 * Format a number as a currency string.
 * @param {number|null|undefined} amount
 * @param {{ symbol?: string, locale?: string }} [currency]
 * @returns {string}  e.g. "$1,234" or "£—"
 */
export function formatCurrency(amount, currency = DEFAULT_CURRENCY) {
  const sym = currency?.symbol || "$";
  if (amount == null || amount === 0) return `${sym}0`;
  return `${sym}${Number(amount).toLocaleString(currency?.locale || "en-US")}`;
}

/**
 * Just the symbol for labels like "Est. Value ($)".
 */
export function currencySymbol(currency) {
  return currency?.symbol || "$";
}
